import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AuthProvider, useAuth } from '@/auth/AuthContext';
import { AppShell } from '@/layouts/AppShell';
import { Login } from '@/pages/Login';
import { Join } from '@/pages/Join';
import { JoinSuccess } from '@/pages/JoinSuccess';
import { EventTickets } from '@/pages/EventTickets';
import { EventTicketsSuccess } from '@/pages/EventTicketsSuccess';
import { Brief } from '@/pages/Brief';
import { Dashboard } from '@/pages/Dashboard';
import { DraftQueue } from '@/pages/DraftQueue';
import { DraftReview } from '@/pages/DraftReview';
import { MemberList } from '@/pages/MemberList';
import { MemberDetail } from '@/pages/MemberDetail';
import { TenantAdmin } from '@/pages/TenantAdmin';

/** The signed-in admin app (everything except the public /join pages). */
function AuthedApp() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="grid min-h-screen place-items-center bg-muted/30 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    return <Login />;
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/brief" element={<Brief />} />
        <Route path="/queue" element={<DraftQueue />} />
        <Route path="/queue/:draftId" element={<DraftReview />} />
        <Route path="/members" element={<MemberList />} />
        <Route path="/members/:profileId" element={<MemberDetail />} />
        <Route path="/admin" element={<TenantAdmin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public, unauthenticated — prospects join here. */}
          <Route path="/join/:tenantId" element={<Join />} />
          <Route path="/join/:tenantId/success" element={<JoinSuccess />} />
          <Route path="/events/:tenantId/:eventId" element={<EventTickets />} />
          <Route path="/events/:tenantId/:eventId/success" element={<EventTicketsSuccess />} />
          {/* Everything else is the authenticated admin app. */}
          <Route path="/*" element={<AuthedApp />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
